// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
	if ( window.location.hash != '' ) {
		setTimeout(() => {
		$('body, html').stop().animate({ scrollTop: ($(window.location.hash).offset().top) - 110 }, 1000);
		}, 2000);
		}
	$(document).ready(function () {
		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		// Main Nav Dropdown
		// $("#primary-nav li").hover(function(){
		// 	$(this).addClass("hover");
		// 	$('ul.submenu',this).fadeIn(200);
		// }, function(){
		// 	$(this).removeClass("hover");
		// 	$('ul.submenu',this).fadeOut(200);
		// });



		/*$('.privary-navigation__item').each(function (index, element) {
			if ($(element).find('.submenu li a').hasClass('active')) {
				$(element).find('.link').addClass('active');
			}
		});*/

		 let itemsNav =  document.querySelectorAll('li.privary-navigation__item')
		 	itemsNav.forEach(li => {
				if(li.parentElement.classList.contains('submenu') && li.firstElementChild.classList.contains('active')) {
					let parentItemsNav = li.parentElement;
					if(parentItemsNav.parentElement.parentElement.parentElement.nodeName == 'LI'){
						parentItemsNav = li.parentElement.parentElement.parentElement
					}
					if(!parentItemsNav.parentElement.firstElementChild.classList.contains('active')){
						parentItemsNav.parentElement.firstElementChild.classList.add('active');
					};
				}
			});

		if ($('.gallery-home').length > 0) {
			$('.gallery-slider-left').slick({
				arrows: true,
				speed: 600,
				slidesToShow: 2,
				slidesToScroll: 1,
				asNavFor: '.gallery-slider-right',
				prevArrow: '.gallery-prev',
				nextArrow: '.gallery-next',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 1,
						},
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
							variableWidth: true,
							centerMode: true,
						},
					},
				],
			});
			$('.gallery-slider-right').slick({
				arrows: true,
				speed: 600,
				slidesToShow: 2,
				slidesToScroll: 1,
				asNavFor: '.gallery-slider-left',
				prevArrow: '.gallery-prev',
				nextArrow: '.gallery-next',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 1,
						},
					},
				],
			});
		}
		// if ($('.form-module-wrapper').length > 0) {
		// 	$('.form-module-wrapper form').addClass('animate-fade top');
		// }
		// if ($('.text-modules-wrapper').length > 0) {
		// 	$('.text-modules-wrapper .text-modules').addClass(
		// 		'animate-fade top'
		// 	); 
		// }

		if ($('.location-states').length > 0) {
			const points_map = document.querySelectorAll(
				'.location-states__item'
			);
			$('.location-states__point').click(function () {
				for (let z = 0; z < points_map.length; z++) {
					if (this.dataset.state == points_map[z].dataset.state) {
						points_map[z].classList.add('active');
						points_map[z].classList.remove('no-active');
					} else {
						points_map[z].classList.remove('active');
						points_map[z].classList.add('no-active');
					}
				}
				$('.location-states__point').removeClass('active');
				$(this).addClass('active');
			});

			const point_first = document.querySelectorAll(
				'.location-states__point'
			);
			point_first[0].click();
		}

		// Obtener el elemento p con la clase "under-special"
		var underSpecial = document.querySelector('.under-special');

		// Obtener el div con la clase "buttons-offers"
		var buttonsOffers = document.querySelector('.buttons-offers');

		// Mover el elemento "under-special" al final del div "buttons-offers"
		if( buttonsOffers )
			buttonsOffers.appendChild(underSpecial);

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
	});

	window.onload = function () {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		let istouch = document.querySelector('.mod-no-touchevents');
		if ($(window).width() > 767) {
			if (istouch) {
				var sk = skrollr.init();
			}
		}

		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		});
	};
})();

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
